import styled from 'styled-components';
import { FC } from 'react';
import { Gender } from '@higo/api';
import { Maturity } from '@higo/common/src/types';
import { BodyImage } from '@higo/common/src/components/Auscultation/HeartAuscultationLegend/BodyImage';
import { media } from '@higo/ui';

export const Container = styled.div`
  width: 9.75rem;
  height: 11.0625rem;

  ${media.mobile.max} {
    margin: 0 auto;
    width: 8rem;
  }
`;

export type HeartAuscultationLegendProps = {
  gender: Gender;
  maturity: Maturity;
};

const StyledFrontBodyImage = styled(BodyImage)`
  max-width: 100%;
`;

export const HeartAuscultationLegend: FC<HeartAuscultationLegendProps> = ({
  gender,
  maturity,
}) => (
  <Container id="heart-ascuation-legend">
    <StyledFrontBodyImage gender={gender} maturity={maturity} />
  </Container>
);
